module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    style: (_vm.statusBorder),
    on: {
      "click": function($event) {
        return _vm.$emit("clicked", _vm.invoice)
      }
    }
  }, [_vm._t("actionsBefore"), _vm._v(" "), _c('v-list-tile-content', [_vm._t("title", function() {
    return [_c('v-list-tile-title', {
      attrs: {
        "slot": "tile-title"
      },
      slot: "tile-title"
    }, [(_vm.invoice.practitioner_id) ? _c('practitioner-faces', {
      attrs: {
        "size": 16,
        "tooltip-prefix": "Created by ",
        "practitioner-ids": [_vm.invoice.practitioner_id]
      }
    }) : _vm._e(), _vm._v(" "), (_vm.invoice.space_id) ? _c('space-faces', {
      attrs: {
        "size": 16,
        "space-ids": [_vm.invoice.space_id]
      }
    }) : _vm._e(), _vm._v(" "), (_vm.invoice.encrypt_password) ? _c('v-icon', {
      attrs: {
        "small": "",
        "color": "info",
        "title": _vm.invoice.encrypt_password
      }
    }, [_vm._v("\n              lock\n            ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.invoice.title))]), _vm._v(" "), _c('v-chip', {
      staticClass: "v-chip--x-small px-0 my-0",
      attrs: {
        "label": "",
        "outline": ""
      }
    }, [_vm._v(" #" + _vm._s(_vm.invoice.id))]), _vm._v(" "), (_vm.withStatus) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      staticStyle: {
        "padding": "0px 5px",
        "margin": "0px",
        "float": "right"
      },
      attrs: {
        "color": _vm.statusColor,
        "text-color": "white",
        "label": ""
      }
    }, [_vm._v(_vm._s(_vm.invoice.status.toUpperCase()) + "\n            ")]) : _vm._e()], 1)]
  }), _vm._v(" "), _vm._t("sub-title", function() {
    return [_c('v-list-tile-sub-title', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-0 ml-1",
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('invoiceDate')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.dateformat(_vm.invoice.date, 'YYYY-MM-DD')))]), _vm._v(" /\n                " + _vm._s(_vm.$t('dueDate')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.dateformat(_vm.invoice.due_date, 'YYYY-MM-DD')))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0 ml-1"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('total')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.invoice.currency, _vm.invoice.invoice_amount)))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('payments')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.invoice.currency, _vm.invoice.amount_paid)))])])], 1)], 1)]
  })], 2), _vm._v(" "), _vm._t("actionsAfter")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-212483cd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/InvoiceListItem.vue
// module id = 1351
// module chunks = 9